module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('SgsRenderNotificationSuccess', {
    model: {
      value: (_vm.notificationSuccess),
      callback: function($$v) {
        _vm.notificationSuccess = $$v
      },
      expression: "notificationSuccess"
    }
  }), _vm._v(" "), _c('SgsRenderNotificationError', {
    model: {
      value: (_vm.notificationError),
      callback: function($$v) {
        _vm.notificationError = $$v
      },
      expression: "notificationError"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12",
    staticStyle: {
      "margin-top": "11px"
    }
  }, [_c('div', {
    staticClass: "pull-right"
  }, [(_vm.showCreateButton) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create()
      }
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('newA')) + " " + _vm._s(_vm.title) + "\n          ")]) : _vm._e()], 1)])])]), _vm._v(" "), (_vm.state.filter._showFilter) ? _c('el-collapse', {
    model: {
      value: (_vm.collapseActiveName),
      callback: function($$v) {
        _vm.collapseActiveName = $$v
      },
      expression: "collapseActiveName"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.$t('filters')
    }
  }, [_c('div', [_c('el-form', {
    ref: "instance",
    attrs: {
      "label-position": "top",
      "rules": _vm.rules,
      "model": _vm.state.filter
    }
  }, [_vm._l((_vm.filterRows), function(row, index) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row.cols), function(col, index) {
      return _c('div', {
        class: 'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width
      }, [_vm._l((col.fields), function(field, index) {
        return [_c('SgsRender', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.getFilterField(field.id).hideOnFilter),
            expression: "!getFilterField(field.id).hideOnFilter"
          }],
          attrs: {
            "type": field.type,
            "moduleType": "form",
            "attr": _vm.getFilterField(field.id),
            "attrConfig": _vm.getAttrConfig(_vm.state.filter, _vm.getColumnName(field.id)),
            "rules": _vm.rules,
            "formIdentifier": _vm.formIdentifier,
            "fieldValue": _vm.state.filter[_vm.getColumnName(field.id)],
            "instance": _vm.state.filter
          },
          on: {
            "input": _vm.updateField,
            "callBusinessRule": _vm.callBusinessRuleFilter
          }
        })]
      })], 2)
    }), 0)
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm._doSearch()
      }
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                " + _vm._s(_vm.$t("search")) + "\n              ")])], 1)])], 2)], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.localList.length) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row margin-bottom-15"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('Pagination', {
    attrs: {
      "pagination": _vm.pagination(_vm.state)
    },
    on: {
      "change-page": _vm._setPage,
      "change-items-per-page": _vm._setItemsPerPage
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped big-table"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": _vm.widthIcons
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('thead', [_c('tr', [(_vm.showShowIcon || _vm.showEditIcon || _vm._resultActions.length > 0) ? _c('th', [_vm._v(_vm._s(_vm.$t('actions')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm._resultDesign), function(field) {
    return _c('th', [_c('span', [_vm._v(_vm._s(_vm.getTableHeaderLabel(field.id)))])])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.localList), function(fieldsDataRow) {
    return (_vm.localList.length) ? _c('tr', [(_vm.showShowIcon || _vm.showEditIcon || _vm._resultActions.length > 0) ? _c('td', {
      staticClass: "buttonIcon"
    }, [(_vm.showShowIcon) ? _c('el-button', {
      attrs: {
        "id": 'show_' + fieldsDataRow.id,
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.show(fieldsDataRow)
        }
      }
    }, [_c('i', {
      staticClass: "glyphicon glyphicon-file"
    })]) : _vm._e(), _vm._v(" "), (_vm.showEditIcon) ? _c('el-button', {
      attrs: {
        "id": 'edit_' + fieldsDataRow.id,
        "type": "primary",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.edit(fieldsDataRow)
        }
      }
    }, [_c('i', {
      staticClass: "glyphicon glyphicon-edit"
    })]) : _vm._e(), _vm._v(" "), _vm._l((_vm._resultActions), function(button) {
      return (_vm._resultActions.length > 0) ? _c('el-button', {
        style: (_vm.returnBackgroundColor(button.backgroundColor)),
        attrs: {
          "size": "mini",
          "title": button.hintPt
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.actionButton(button, fieldsDataRow)
          }
        }
      }, [_c('i', {
        class: _vm.renderIcon(button.icon)
      })]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm._resultDesign), function(field) {
      return _c('td', {
        attrs: {
          "data-th": _vm.getFormFieldLabel(field)
        }
      }, [_c('SgsRender', {
        attrs: {
          "type": field.type,
          "moduleType": "list",
          "attr": field,
          "fieldValue": fieldsDataRow[_vm.getFormField(field.id).columnName],
          "formIdentifier": _vm.formIdentifier
        }
      })], 1)
    })], 2) : _vm._e()
  }), 0)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBottomPagination(_vm.state)),
      expression: "showBottomPagination(state)"
    }],
    staticClass: "row margin-top-15"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('Pagination', {
    attrs: {
      "pagination": _vm.pagination(_vm.state)
    },
    on: {
      "change-page": _vm._setPage,
      "change-items-per-page": _vm._setItemsPerPage
    }
  })], 1)])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-272a870c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/module/components/ModuleList.vue
// module id = 902
// module chunks = 2